import { useAtomValue } from 'jotai'
import { FC, useMemo } from 'react'
import { PropertyRecordsDetailsSales } from 'src/components/insights/property-records/details/sales'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { sortSales } from 'src/utils/property-records'
import { parcelPropertyRecords } from 'src/v2/state/owner-reveal/parcel-property-records'

export const ParcelPropertySalesContent: FC = () => {
  const data = useAtomValue(parcelPropertyRecords)

  const sortedSalesData = useMemo(() => {
    if (!data) {
      return []
    }

    return sortSales(data.sales)
  }, [data])

  if (!sortedSalesData.length) {
    return <UnavailableCardContent message="Sorry, but we couldn't find the information requested for this parcel." />
  }

  return <PropertyRecordsDetailsSales sales={sortedSalesData} />
}
